module.exports = __webpack_public_path__ + "icon-arrow-megamenu.jpg?f995318dd2248903dbda403d760cff55";